import { IReservedStockInfo } from 'types/stockOrders';
import './ListOfReservedStocks.scss';
import ReservedStockCard from './ReservedStockCard/ReservedStockCard';

interface IListOfReservedStocks {
  reservedStockInfo: IReservedStockInfo;
}

const ListOfReservedStocks = ({ reservedStockInfo }: IListOfReservedStocks) => {
  const { items } = reservedStockInfo;
  return (
    <div className="listOfReservedStocks">
      {items.map((item, index) => (
        <ReservedStockCard key={`single-reserved-stock-${item.orderId}`} {...item} isLast={index === items?.length - 1} />
      ))}
    </div>
  );
};

export default ListOfReservedStocks;
